/**
 * useEscapeKey — call a handler when the user presses Escape.
 *
 * Replaces the duplicated pattern across 18+ components:
 *   useEffect(() => {
 *     const handler = (e: KeyboardEvent) => {
 *       if (e.key === 'Escape') close();
 *     };
 *     document.addEventListener('keydown', handler);
 *     return () => document.removeEventListener('keydown', handler);
 *   }, [isOpen]);
 *
 * Usage:
 *   useEscapeKey(() => setIsOpen(false), isOpen);
 */
import { useEffect } from 'react';

export function useEscapeKey(
  onEscape: () => void,
  enabled = true,
): void {
  useEffect(() => {
    if (!enabled) return;

    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onEscape, enabled]);
}
